// extracted by mini-css-extract-plugin
export var card = "_b2-1";
export var container = "_b2-0";